module.exports = __webpack_public_path__ + "img/behance.c44c0b14.svg";